import {
  LuxModal,
  LuxModalFooter,
  LuxModalHeader,
  LuxTypography,
  Stack,
} from '@gemini/fe-ds-core';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { useTranslation } from 'react-i18next';
interface RemoveModalProps {
  title: string;
  subtitle: string;
  yesAction: () => void;
  open: boolean;
  onClose: () => void;
  fromViewDoctors?: boolean;
}

const RemoveModal = ({
  title,
  subtitle,
  yesAction,
  open,
  onClose,
}: RemoveModalProps) => {
  const { t } = useTranslation();

  const setIsNewPatientStarted = useOnlineBookingStore(
    state => state.setIsNewPatientStarted,
  );

  const handleRemove = () => {
    setIsNewPatientStarted(false);
    yesAction();
    onClose();
  };

  return (
    <LuxModal
      type="center"
      open={open}
      onClose={onClose}
      size="small"
      header={
        <>
          <Stack height={'1.5rem'} />
          <LuxModalHeader
            title={
              <Stack direction={'column'} gap={'1rem'}>
                <LuxTypography variant="heading3">{t(title)}</LuxTypography>
                <LuxTypography variant="textMdRegular">
                  {t(subtitle)}
                </LuxTypography>
              </Stack>
            }
            darkMode={false}
            enableCloseIcon
            onClose={onClose}
          />
        </>
      }
      footer={
        <LuxModalFooter
          secondaryButtonText={t('modalLabels.close') || 'Close'}
          primaryButtonText={t('modalLabels.yesRemove') || 'Yes, remove'}
          onPrimaryButtonClick={() => handleRemove()}
          onSecondaryButtonClick={() => onClose()}
          justifyContent="space-between"
        />
      }
    >
      <></>
    </LuxModal>
  );
};

export default RemoveModal;
